import { combineReducers } from 'redux';

import isLoading from './isLoading';
import isOpen from './isOpen';

/**
 * @typedef {{
 *  isOpen: import('./isOpen').IsOpenState,
 *  isLoading: import('./isLoading').IsLoadingState,
 * }} AuditState
 */

export default combineReducers({
  isOpen,
  isLoading,
});
